import { render, staticRenderFns } from "./PlantIcon.vue?vue&type=template&id=57b0f2d7"
import script from "./PlantIcon.vue?vue&type=script&lang=js"
export * from "./PlantIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports